// 注释解释1：暂时屏蔽全屏交互，保不准后面又要加上全屏交互，暂时不删除代码

// 注释解释1
// import React, { useMemo, useState } from 'react';
import React, { useMemo } from 'react';
import classnames from 'classnames';
// 注释解释1
// import { Modal } from 'tea-component';
// 注释解释1
// import SvgIcon from '@home/components/SvgIcon';
import VersionFigureContent from './Content';

import type { IBaseProps } from '@home/types/common';
import type { IVersionFigure } from '@home/components/VersionPopup/VersionFigure/types';

import './index.scss';

// 历史数据是string、新数据是string[]

interface IVersionFigureProps extends IBaseProps {
  versionName: string;
  versionContent: string;
}

const convert2Array = (data: any): any[] => {
  if (Array.isArray(data)) return data;
  return data ? [data] : [];
};

const VersionFigure: React.FC<IVersionFigureProps> = (props) => {
  const { style, className, versionName, versionContent } = props;

  // 注释解释1
  // const [isOpen, setOpen] = useState(false);

  const versionFigures = useMemo<IVersionFigure[]>(() => {
    let result: any[];
    try {
      result = JSON.parse(versionContent);
      result = result?.map((item) => {
        const { img_url: imgUrl } = item || {};
        return { ...item, img_url: convert2Array(imgUrl) };
      });
    } catch (exception) {
      result = [];
    }
    return Array.isArray(result) ? result : [];
  }, [versionContent]);

  // 注释解释1
  // const hasImgs = useMemo<boolean>(() => {
  //   if (!Array.isArray(versionFigures) || !versionFigures.length) return false;
  //   return versionFigures.some((versionFigure) => {
  //     const { img_url: imgUrl } = versionFigure || {};
  //     return Array.isArray(imgUrl) && imgUrl.length > 0;
  //   });
  // }, [versionFigures]);

  return (
    <div style={style} className={classnames('dbh-version-figure', className)}>
      {/* 注释解释1 */}
      {/* {hasImgs && (
        <div
          className="dbh-version-figure__fullscreen-icon-wrapper"
          onClick={() => {
            setOpen(true);
          }}
        >
          <SvgIcon className="dbh-version-figure__fullscreen-icon" type="focus-icon" />
        </div>
      )} */}
      <h2 className="dbh-version-figure__title">{versionName || '-'}</h2>
      <VersionFigureContent versionFigures={versionFigures} />
      {/* 注释解释1 */}
      {/* <Modal
        className="version-history-modal"
        size={1000}
        caption={versionName}
        visible={isOpen}
        onClose={() => {
          setOpen(false);
        }}
      >
        <Modal.Body>
          <div className="version-modal-context">
            <VersionFigureContent
              className="dbh-version-figure__content--fullscreen"
              isFullscreen
              versionFigures={versionFigures}
            />
          </div>
        </Modal.Body>
      </Modal> */}
    </div>
  );
};

export default React.memo(VersionFigure);
